document.addEventListener('DOMContentLoaded', () => {

  const menu =
    document.querySelector('[data-nmh]');

  const header =
    document.querySelector('header-component');

  if (!menu || !header) return;

  const isHome =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/';

  function updateHeader() {

    const isSticky =
      header.dataset.stickyState === 'active';

    /* acompanha o comportamento do header em todas as páginas */
    menu.classList.toggle(
      'is-scrolled',
      isSticky
    );

    /* páginas internas ficam pretas o tempo todo */
    menu.classList.toggle(
      'is-dark',
      !isHome
    );

  }

  updateHeader();

  new MutationObserver(
    updateHeader
  ).observe(header, {
    attributes: true,
    attributeFilter: [
      'data-sticky-state'
    ]
  });

});